export default "__VITE_ASSET__Dr08Lw$F__"